import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ProductService } from 'src/app/services/products.service';
import { ActivatedRoute, Router } from '@angular/router';
import Swal from 'sweetalert2';
import { VolumetricValidation, regexPattern } from 'src/app/models/validator';
import { AppCoreService } from 'src/app/services/app-core.service';
import * as $ from 'jquery';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Title } from '@angular/platform-browser';
import { Utilities } from 'src/app/models/utilities';
import { GeoService } from 'src/app/services/geo.service';
import { finalize, forkJoin, lastValueFrom } from 'rxjs';

@Component({
  selector: 'app-edit',
  templateUrl: './edit.component.html',
  styleUrls: ['./edit.component.scss']
})
export class EditCitiesComponent {
  cityform: FormGroup;
  permConfig = {
    isViewAllowed: false,
    isAddAllowed: false,
    isEditAllowed: false,
    isDeleteAllowed: false
  };
  isFormSubmitted = false;
  countryList: any[] = [];
  stateList: any[] = [];
  cityId: number;

  constructor(
    private formBuilder: FormBuilder,
    private appCoreService: AppCoreService,
    private productService: ProductService,
    private geoService: GeoService,
    private route: ActivatedRoute,
    private router: Router,
    private ngxLoaderService: NgxUiLoaderService,
    private titleService: Title,
    private utilities: Utilities,
  ) {
    titleService.setTitle('Cities');
  }

  async ngOnInit() {
    this.cityId = this.route.snapshot.params['id'];
    this.cityform = this.formBuilder.group({
      ddlCountry: [null, Validators.compose([Validators.required])],
      ddlState: [{ value: null, disabled: false }],
      txtcityCode: [{ value: null, disabled: true }, Validators.compose([Validators.required, Validators.maxLength(3)])],
      txtcityName: [null, Validators.compose([Validators.required, Validators.maxLength(70)])],
      txtStatus: [true]
    });
    this.checkPermission();
    await this.bindCountries();
    this.getCityById();
  }

  checkPermission(): any {
    const userData = this.appCoreService.GetUserData();
    const permission = userData.config.filter(x => x.categoryname === 'Cities');
    if (permission.length) {
      this.permConfig.isViewAllowed = permission[0].view;
      this.permConfig.isAddAllowed = permission[0].add;
      this.permConfig.isEditAllowed = permission[0].edit;
      this.permConfig.isDeleteAllowed = permission[0].delete;
    }
  }

  async getCityById() {
    try {
      this.ngxLoaderService.start();
      this.geoService.getCityById(this.cityId).subscribe(async (res) => {
        if (res?.success) {
          this.ngxLoaderService.stop();
          // console.log("getCityById", res.data);
          const cityData = res?.data[0];
          // this.cityform.patchValue({
          //   ddlCountry: this.countryList.find(x => x.id === cityData?.countryid)?.isocode,
          //   ddlState: this.stateList.find(x => x.id === cityData?.stateid)?.isocode,
          //   txtcityCode: cityData?.code,
          //   txtcityName: cityData?.name,
          //   txtStatus: cityData?.isactive
          // });
          const countryIsoCode = this.countryList.find(x => x.id === cityData?.countryid)?.isocode;

          // Set the country first
          this.cityform.patchValue({
            ddlCountry: countryIsoCode,
            txtcityCode: cityData?.code,
            txtcityName: cityData?.name,
            txtStatus: cityData?.isactive
          });
          // Fetch states for the selected country and then patch the state

          await this.bindStatesByCountryCode(countryIsoCode);
          const stateIsoCode = this.stateList.find(x => x.id === cityData?.stateid)?.isocode;
          stateIsoCode && this.cityform.patchValue({ ddlState: stateIsoCode});

        } else if (res && !res.success) {
          this.ngxLoaderService.stop();
          this.appCoreService.showMessage(res.data.err_msg, "Error", 'error')
        }
      });
    } catch (err) {
      this.ngxLoaderService.stop();
      console.error(err);
    }
  }


  updateCity() {
    try {
      if (!this.permConfig.isAddAllowed) {
        this.warningDialog('No access to Add.');
        return;
      }
      this.isFormSubmitted = true;
      if (this.permConfig.isAddAllowed && this.cityform.valid) {

        const selectedCountryIsoCode = this.cityform.get('ddlCountry').value;
        const selectedStateIsoCode = this.cityform.get('ddlState').value;
        const selectedCountry = this.countryList.find((country: any) => country.isocode === selectedCountryIsoCode);
        const selectedState = this.stateList.find((city: any) => city.isocode === selectedStateIsoCode);

        const requestObj = {
          id: this.cityId,
          countryid: selectedCountry?.id,
          stateid: selectedState?.id,
          // isocode: selectedCountry?.code + '-' + selectedState?.code + '-',
          citycode: this.cityform.get('txtcityCode').value,
          cityname: this.cityform.get('txtcityName').value,
          status: this.cityform.get('txtStatus').value
        }
        // console.log("REQOBJ", requestObj)
        this.ngxLoaderService.start();
        this.geoService.updateCity(requestObj).subscribe((res) => {
          if (res?.success) {
            this.ngxLoaderService.stop();
            this.openConfirmationDialog("Record Updated Successfully");
          } else if (res && !res.success) {
            this.ngxLoaderService.stop();
            this.appCoreService.showMessage(res.data.err_msg, "Error", 'error')
          }
        })
      }
    }
    catch (err) {
      console.error(err);
    }
  }


  async bindCountries() {
    try {
      const res = await lastValueFrom(this.geoService.GetAllCountries());
      if (res && res.success) {
        const metaInfo = this.appCoreService.GetUserData()?.metaInfo;
        const defaultCountryCode = metaInfo.defaultcountry;

        if (metaInfo.operationtype.includes('Domestic') && metaInfo.operationtype.includes('International')) {
          this.countryList = res.data;
        } else if (metaInfo.operationtype.includes('Domestic')) {
          this.countryList = res.data.filter(item => item.isocode === defaultCountryCode);
          this.cityform.get('ddlCountry').setValue(defaultCountryCode);
          this.cityform.get('ddlCountry').disable();
        } else if (metaInfo.operationtype.includes('International')) {
          this.countryList = res.data.filter(item => item.isocode !== defaultCountryCode);
        } else {
          this.countryList = res.data;
        }
        // this.onCountryChange();
      }
    } catch (e) {
      console.error(e);
    }
  }

  async onCountryChange() {
    const selectedCountryIsoCode = this.cityform.get('ddlCountry').value;
    const selectedCountry = this.countryList.find((country: any) => country.isocode === selectedCountryIsoCode);
    // console.log("selectedCountry?.id", selectedCountry?.id)
    if (selectedCountry) {
      this.cityform.get('ddlState').reset();
      await this.bindStatesByCountryCode(selectedCountryIsoCode);
    } else {
      this.cityform.patchValue({
        ddlState: []
      });
    }
  }

  async bindStatesByCountryCode(countryCode?: string): Promise<void> {
    try {
      if (countryCode?.length) {
        const observable = this.geoService.GetAllStates({ countrycode: countryCode });
        const res = await lastValueFrom(observable);
        if (res && res.success) {
          this.stateList = res.data;
        }
      }
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  warningDialog(msg: any) {
    Swal.fire({
      // title: 'Warning!',
      text: msg,
      icon: 'warning',
      confirmButtonText: 'OK',
      allowEscapeKey: false,
      allowOutsideClick: false
    });
  }

  async openConfirmationDialog(msg: any) {
    const res = await Swal.fire({
      // title: 'Success',
      text: msg,
      icon: 'success',
      confirmButtonText: 'OK',
      allowEscapeKey: false,
      allowOutsideClick: false
    })
    if (res.isConfirmed) {
      this.router.navigate(['/setup/geo/cities'])
    }
  }





}